'use strict'
//demo.js - script to control the demo
import $ from 'jquery';
import Websocket from './Websocket.js';
// import BulletChart from './components/BulletChart.js';
import BarChart from './components/BarChart.js';
import constructChartData from './calcChart.js';
import { ResultList, Sidebar, FlightOverview } from './components';
import {sortByCarbon, sortByPrice} from './sort.js';
const resultsElement = document.getElementById('results');
const overviewSectionElement = document.getElementById('overview-section');
const factorsDiv = document.getElementById('factors-div');


const ws = new Websocket();
const advancedOptions = new Sidebar('sidebar-tab');
const flightOverview = new FlightOverview();
let priceChart = null;
let carbonChart = null;

window.global = {
    constants: {
        tabWidth: 800,
        tabHeight: 95,
        sidebarOffset: 300,
    },
    state: {
        id: null,
        blurred: null,
        ready: false,
    }
}

document.getElementById("demo-button").onclick = demoSearch;

//trigger sort by carbon
document.getElementById('factor-carbon').onclick = sortByCarbon;

$('#factor-carbon').hover(function(){
    $('#factor-carbon > .icon-sort').addClass('icon-active');

}, function(){
    $('#factor-carbon > .icon-sort').removeClass('icon-active');
});


//trigger sort by carbon
document.getElementById('factor-price').onclick = sortByPrice;

$('#factor-price').hover(function(){
    $('#factor-price > .icon-sort').addClass('icon-active');

}, function(){
    $('#factor-price > .icon-sort').removeClass('icon-active');
});

/*
//save trips
$('#results').on('click', '.save-btn', function(){
    const flightList = $(this).parent().find('.summary-list'); 
    const carbon = $(this).parent().find('.carbon-container');
    const clickedID = $(this).prev()[0].id.split('-').pop(); //getting the last element of the id (i.e. the index for result)
    const slice = window.global.data.body.trips.tripOption[clickedID].slice;
    
    //caculate the total distance for the entire trip
    let totalDistance = 0;
    for (let i = 0; i < slice.length; i++)
    {
        const segment = slice[i].segment;
        for (let j = 0; j < segment.length; j++)
        {
            console.log(+segment[j].distance);
            totalDistance += +segment[j].distance;
        }
    }

    console.log(flightList[0].getElementsByClassName('flight-summary-iata'));
    const parameters = {
        origin : flightList[0].getElementsByClassName('flight-summary-iata')[0].innerText,
        dest   : flightList[0].getElementsByClassName('flight-summary-iata')[1].innerText,
        //dest   : flightList[flightList.length-1].getElementsByClassName('flight-summary-iata')[0].innerHTML,
        carbon : carbon[0].innerHTML.substring(0, carbon[0].innerHTML.indexOf('k')).replace(' ',''),
        ddate  : $('#dDate')[0].innerText,
        rdate  : ($('#rDate')[0] != undefined)? $('#rDate')[0].innerText : null,
        distance: Math.round(totalDistance)
    }
    console.log(parameters);

    $.post('/save', parameters, function(callbackMessage){
        //displayMessage(callbackMessage);
    });

});

*/

ws.socket.on('message', function(data){
	console.log('Received data from the server!', data);
    window.global.data = data;

	// Make the results visible and add the search results
    overviewSectionElement.style.opacity = 1;
    overviewSectionElement.style.display = 'block';
    resultsElement.style.opacity = 1;
    factorsDiv.style.opacity = 1;
    factorsDiv.style.display = 'block';


    const flightResults = new ResultList(data);
    flightResults.generateResults();
    flightResults.addCarbonValues();

    sortByCarbon();     //by default, results are sorted by carbon
    // Initialize or update the flight overview and bar charts
    const chartData = constructChartData();
    console.log(chartData);
    
    if(window.global.state.ready) {
        flightOverview.update(data);
        //carbonChart.showBar(chartData);
        carbonChart.showBar();
    } else {
        //flightOverview.displayDemo(data);
        flightOverview.append(data);
        carbonChart = new BarChart('#carbon-chart-container', chartData);
        window.global.carbonChart = carbonChart;
        //carbonChart.showBar(chartData);
        carbonChart.showBar();
    }
});

function demoSearch(){

	resultsElement.style.opacity = 0;
	resultsElement.style.height = '100vh';
	overviewSectionElement.style.opacity = 0;
    factorsDiv.style.opacity = 0;
    //factorsDiv.style.display = 'block';
    document.getElementById("gif-background").style.display = "none";

	// Scroll down to the top of the results
    $('html, body').animate({
        scrollTop: $("#scroll-section").offset().top
    }, 2000);
    
	var input = {};
	input.demo = "true";
	console.log("requesting demo from the client");
	ws.socket.send(input);
}



// WEBPACK FOOTER //
// ./demo.js